import React, { ReactNode } from 'react';

import { ContractSearch } from 'pricing/components/contractSearch/contractSearch';
import { Layout } from 'shared/components/layout/Layout';
import { ContractProvider } from '../useContractState/useContractState';

interface Props {
  children: ReactNode;
}

function ContractLayout(props: Props) {
  const { children } = props;
  return (
    <Layout navigationCenterTools={<ContractSearch />}>
      <ContractProvider>{children}</ContractProvider>
    </Layout>
  );
}

export default ContractLayout;
